import { render, staticRenderFns } from "./ManageVendor.vue?vue&type=template&id=7a4b729c&scoped=true&"
import script from "./ManageVendor.vue?vue&type=script&lang=js&"
export * from "./ManageVendor.vue?vue&type=script&lang=js&"
import style0 from "./ManageVendor.vue?vue&type=style&index=0&id=7a4b729c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4b729c",
  null
  
)

export default component.exports